import { ApiError, Box, Flex, StatusBar, StatusBarProps, Title } from "@shared/primitive-components"
import { PropsWithChildren, ReactNode } from "react"
import * as styles from "./screenContentStyles"

export type ScreenContentDataTestIds = {
  root?: string
  title?: string
}

type ScreenContentChildProps = {
  apiFailed?: boolean
}

const ScreenContentChildren = ({ apiFailed, children }: PropsWithChildren<ScreenContentChildProps>) => {
  if (apiFailed) return <ApiError />
  return <>{children}</>
}

ScreenContentChildren.defaultProps = {
  apiFailed: false,
}

export type ScreenContentProps = ScreenContentChildProps & {
  title?: string | ReactNode
  dataTestIds?: ScreenContentDataTestIds
  statusBar?: StatusBarProps
  showEmptyLayoutWhenLoading?: boolean
  PreviousPolicyDropdown?: JSX.Element | null
}

export const ScreenContent = ({
  title,
  dataTestIds,
  statusBar,
  PreviousPolicyDropdown,
  ...props
}: PropsWithChildren<ScreenContentProps>) => (
  <Flex css={styles.bottomMargin} as="main" flexDirection="column" data-testid={dataTestIds?.root}>
    {statusBar?.placement === `top` && <StatusBar {...statusBar} />}
    {title && (
      <Box css={styles.titleContainer}>
        <Box css={() => styles.titleFlex(!!PreviousPolicyDropdown)}>
          {typeof title === `string` ? (
            <Title data-testid={dataTestIds?.title} css={styles.title}>
              {title}
            </Title>
          ) : (
            <>{title}</>
          )}
          {PreviousPolicyDropdown && PreviousPolicyDropdown}
        </Box>
      </Box>
    )}
    {statusBar?.placement === `belowTitle` && <StatusBar {...statusBar} />}
    <ScreenContentChildren {...props} />
  </Flex>
)

ScreenContent.defaultProps = {
  dataTestIds: undefined,
  belowTitle: undefined,
  statusBar: undefined,
  PreviousPolicyDropdown: undefined,
  ...ScreenContentChildren.defaultProps,
}
